module.exports = "<span>\n    <i ng-if=\"state === 'success'\" class=\"icon material-icons\">&#xE5CA;</i>\n    <i ng-if=\"state === 'warning'\" class=\"icon material-icons\">&#xE001;</i>\n    <i ng-if=\"state === 'error'\" class=\"icon material-icons\">&#xE14C;</i>\n    &ensp;\n</span>\n"


//////////////////
// WEBPACK FOOTER
// ./Client/app/tasks/directives/statusIcon/status-icon.html
// module id = 688
// module chunks = 0